import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getAssignBrokerCourse,
  getAssignCourse,
  getAssignCourseClear,
  getSelectedCatId,
  showBuyModal,
} from "../../redux/courses/actions";
import BuyProductModal from "../modal/BuyProductModal";
import ConfirmModal from "../modal/ConfirmModal";
import Slider from "react-slick/";
import Carousel from "react-bootstrap/Carousel";
import { ProgressBar } from "react-bootstrap";
import { clickStreamUser, SessionKeys } from "../../utils/AppUtils";
import PrevArrow from "./PrevArrow";
import NextArrow from "./NextArrow";
import _ from "lodash";
import ImageComponent from "../Layouts/ImageComponent";
import ProviderComponent from "../Layouts/ProviderComponent";
import ProductCardComponent from "../NewDesign/ProductCard/ProductCardComponent";
// import { learningPathDetailResponse } from '../../redux/product/actions';

const SliderMyLearningPathListing = (props) => {
  const {
    learningPathList,
    pageType,
    setFavoriteCourse,
    closeModal,
    setCloseModal,
    hasDescription,
    showBlankCard,
    isOnboarding,
  } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const [learningPathData, setCourseData] = useState({})
  const auth = useSelector((state) => state.auth);
  const authBroker = useSelector((state) => state.auth.authBroker);
  const [newCardData, setNewCardData] = useState([]);

  const redirectToPage = (learningId, type, is_assigned) => {
    if (type === "onboarding") {
      navigate(
        "/my-onboarding?id=" + learningId + "&isExplore=" + !is_assigned
      );
    } else {
      navigate("/learning-paths?id=" + learningId);
    }
  };

  const footerClicked = (course) => {
    console.log(course);
  };
  const bannerClicked = (course) => {
    console.log(course);
  };
  const footerLineRender = (course) => {
    return (
      <></>
      // <span className="signup-btn">Included with paid subscriptions</span>
    );
  };

  useEffect(() => {
    // if (!_.isEmpty(learningPathList)) {
    //   let prodArr = [];
    //   for (let lp of learningPathList) {
    //     let tags = [];
    //     let btnTitle = "Start learning";
    //     if (lp.provider?.provider_display_name) {
    //       tags.push(lp.provider.provider_display_name);
    //     }
    //     tags.push("Learning Path");
    //     if (lp.course_count) {
    //       tags.push(
    //         `${lp.course_count} Course${lp.course_count > 1 ? "s" : ""}`
    //       );
    //     }
    //     if (lp.video_count) {
    //       tags.push(`${lp.video_count} Course${lp.video_count > 1 ? "s" : ""}`);
    //     }
    //     // if (lp.duration && lp.durationUnit) {
    //     //   tags.push(`${lp.duration} ${lp.durationUnit}`)
    //     // }
    //     // if (lp.views) {
    //     //   tags.push(`${lp.views} View${lp.views > 1 ? 's' : ''}`)
    //     // }
    //     if (lp.prgm_progress > 0 && lp.prgm_progress < 100) {
    //       btnTitle = "Resume learning";
    //     } else if (lp.prgm_progress >= 100) {
    //       btnTitle = "Revisit learning";
    //     }
    //     prodArr.push({
    //       id: lp?.id,
    //       is_like: lp?.is_like ? lp?.is_like : false,
    //       is_bookmark: lp?.is_bookmark ? lp?.is_bookmark : false,
    //       dbId: lp?.list_id,
    //       productType: lp?.entity_type,
    //       productOrigin: lp?.source,
    //       title: lp.prgm_nm,
    //       logoURL: lp.provider?.provider_img ? lp.provider?.provider_img : "",
    //       bannerURL: lp.thumbnail,
    //       tagsArray: tags,
    //       description: lp.prgm_description,
    //       btnTitle: btnTitle,
    //       progress: lp.crs_progress,
    //       btnAction: () =>
    //         redirectToPage(lp.id, lp.entity_type, lp.is_assigned),
    //       descAction: bannerClicked,
    //       bannerAction: bannerClicked,
    //       footerLineComp: footerLineRender(),
    //       showLikeMenu: true,
    //       showHeader: true,
    //       showBody: lp.prgm_description ? true : false,
    //       showFooter: true,
    //       showProgresss: false,
    //       cardClassName: "",
    //       rightBtnIcon: "/images/arrow-right.svg",
    //       lefttBtnIcon: "",
    //     });
    //   }
    //   console.log("PROD ARR", prodArr);
    //   setNewCardData(prodArr);
    // }
  }, [learningPathList]);

  return (
    <div className="slider-course-listing row gx-sm-5 mt-5">
      {learningPathList.length === 0
        ? ""
        : learningPathList.map((course, i) => {
            if (course.title && i < 3) {
              return (
                <ProductCardComponent {...course} key={`course-${i + 1}`} />
              );
            }
          })}
    </div>
  );
};

export default SliderMyLearningPathListing;
